/**
 * Used for drag and drop operations containing a complete
 * Python code sample.
 */
export const pythonSnippetMediaType = "application/x.python-snippet";
